"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HereMap = void 0;
var React = _interopRequireWildcard(require("react"));
var GeneralHooks = _interopRequireWildcard(require("@algo/hooks"));
var InitializeHooks = _interopRequireWildcard(require("../map-hooks/Initializers"));
var MapHooks = _interopRequireWildcard(require("../map-hooks/MapHooks"));
var MarkerHooks = _interopRequireWildcard(require("../map-hooks/Markers"));
var GeoJsonHooks = _interopRequireWildcard(require("../map-hooks/geojson/features"));
var SC = _interopRequireWildcard(require("./Styled"));
var CONST = _interopRequireWildcard(require("../constants"));
var _bounds = require("../map-hooks/geojson/bounds");
var _herecontext = require("@algo/herecontext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var renderWrapStyle = CONST.renderWrapStyle;
var HereMap = function HereMap(props) {
  /**************************************************************************
      PROPS
   *************************************************************************/
  var mapConfig = props.mapConfig,
    rounded = props.rounded,
    showUI = props.showUI,
    customControls = props.customControls,
    showBounds = props.showBounds,
    showTrafficLayer = props.showTrafficLayer,
    _props$scheme = props.scheme,
    scheme = _props$scheme === void 0 ? "normal.day.grey" : _props$scheme,
    _props$disableBehavio = props.disableBehavior,
    disableBehavior = _props$disableBehavio === void 0 ? false : _props$disableBehavio,
    _props$listeners = props.listeners,
    listeners = _props$listeners === void 0 ? null : _props$listeners,
    _props$markers = props.markers,
    markers = _props$markers === void 0 ? null : _props$markers,
    _props$features = props.features,
    features = _props$features === void 0 ? null : _props$features,
    _props$featureCallbac = props.featureCallback,
    featureCallback = _props$featureCallbac === void 0 ? function (data) {} : _props$featureCallbac,
    _props$storeMapAndPla = props.storeMapAndPlatform,
    storeMapAndPlatform = _props$storeMapAndPla === void 0 ? function () {} : _props$storeMapAndPla;

  // check if user wants rounded corners
  if (rounded) renderWrapStyle = _objectSpread(_objectSpread({}, renderWrapStyle), {}, {
    borderRadius: rounded
  });

  /**************************************************************************
      STATE
   *************************************************************************/
  var hereContext = React.useContext(_herecontext.HereContext);

  /**************************************************************************
      CALCULATED VALUES & BREVITY NAMES
   *************************************************************************/

  // the brains behind HERE Map
  var HERE_SCRIPT = {
    src: CONST.HERE_SCRIPT_BUNDLE_URI,
    type: "module",
    onLoad: function onLoad() {
      hereContext.setHEREScriptLoaded(true);
    }
  };
  var HERE_SCRIPT_HARP = {
    src: CONST.HERE_SCRIPT_HARP,
    type: "text/javascript",
    onLoad: function onLoad() {
      hereContext.setHARPScriptLoaded(true);
    }
  };

  // tag recommended in HERE docs
  var HERE_MOBILE_OPTIMIZATION = {
    name: "viewport",
    content: CONST.MOBILE_OPTIMIZATION_META_TAG
  };

  // the stylesheet for the User Controls overlay on map
  var HERE_CONTROLS_STYLESHEET = {
    href: CONST.HERE_SCRIPT_UI_URI,
    rel: "stylesheet",
    type: "text/css"
  };

  /**************************************************************************
      EFFECTS
   *************************************************************************/

  // appends HERE map script to document
  GeneralHooks.useAddScript(HERE_SCRIPT);
  GeneralHooks.useAddHarpScript(HERE_SCRIPT_HARP, hereContext.HEREScriptLoaded);

  // appends meta tag to document                          
  GeneralHooks.useAddMeta(HERE_MOBILE_OPTIMIZATION);
  // appends link tag to document
  GeneralHooks.useAddLink(HERE_CONTROLS_STYLESHEET);

  // checks if HereMap script has been previous loaded in this window
  InitializeHooks.useCheckForExistingScript(function () {
    hereContext.setHEREScriptLoaded(true);
    hereContext.setHARPScriptLoaded(true);
  });

  // Initialize communication with back-end when API script(s) have loaded
  var _InitializeHooks$useI = InitializeHooks.useInitializeCommunication(hereContext.HEREScriptLoaded && hereContext.HARPScriptLoaded),
    _InitializeHooks$useI2 = _slicedToArray(_InitializeHooks$useI, 2),
    platform = _InitializeHooks$useI2[0],
    platformError = _InitializeHooks$useI2[1];

  // Handle initializing the map after the pre-reqs have loaded
  var _InitializeHooks$useI3 = InitializeHooks.useInitializeMap(platform, showUI, customControls, mapConfig, scheme),
    map = _InitializeHooks$useI3.map,
    ui = _InitializeHooks$useI3.ui,
    behavior = _InitializeHooks$useI3.behavior,
    mapError = _InitializeHooks$useI3.mapError;

  // Handle passing parent a reference to map object
  MapHooks.useStoreMapAndPlatform(map, platform, storeMapAndPlatform);
  if (disableBehavior) behavior === null || behavior === void 0 ? void 0 : behavior.disable();

  // Add ( and remove on dismount ) an event listener for page resize which should resize the map appropriately
  MapHooks.useResizeMapWithWindow(map);

  // Watch the MapConfig theme value and update theme accordingly
  MapHooks.useRetheme(scheme, map, platform);

  // Watch the MapConfig showSpeeds value and update the map traffic layer accordingly
  MapHooks.useTrafficLayer(showTrafficLayer, map, platform, scheme.includes("vector"));

  // This effect handles drawing polygons to a loaded map
  GeoJsonHooks.useDrawFeatures(map, features, featureCallback);

  // This effect handles drawing bounds polygon to loaded map
  (0, _bounds.useShowBounds)(map, showBounds);

  // This effect handles drawing markers to a loaded map
  MarkerHooks.useDrawMarkers(map, markers);

  // This effect handles updating center and zoom of a loaded map
  MapHooks.useCenterAndZoom(map, mapConfig);

  // This effect handles adding event listeners to loaded map
  MapHooks.useAddMapListeners(map, listeners);

  /**************************************************************************
      HANDLERS & HELPER FUNCTIONS
   *************************************************************************/

  /**************************************************************************
      ERROR RENDER
   *************************************************************************/
  if (mapError) {
    return /*#__PURE__*/React.createElement("div", {
      style: renderWrapStyle
    }, /*#__PURE__*/React.createElement(SC.StyledError, null, "There was an error loading the map script(s):"), /*#__PURE__*/React.createElement(SC.StyledError, null, "Map Error: ".concat(mapError, " \n Platform Error: ").concat(platformError, "\n")));
  }

  /**************************************************************************
      PRIMARY RENDER
   *************************************************************************/
  return /*#__PURE__*/React.createElement("div", {
    style: renderWrapStyle
  }, /*#__PURE__*/React.createElement(SC.StyledMapContainer, {
    id: CONST.MAP_CONTAINER_ID,
    rounded: rounded,
    style: {
      width: "100%",
      height: "100%"
    }
  }));
};
exports.HereMap = HereMap;
var _default = HereMap;
exports.default = _default;